// building Codes
export const buildingCodesTooltip = {
  header:
    "Building Codes are used for separating rooms for financial purposes.  Each Building can have a separate Security Breakpoint (so some users can access rooms in that building, while other cannot)",
  buildingCode: "The description used within the software.",
  buildingName: "The description used on reports",
  taxExemptCategory:
    "The preferred tax categories that can be exempted for this building. Tax Exempt Categories are created in the system, please use categories built in workbook.",
  active: "When enabled, it indicates that the building is active.",
};

// Room Features
export const roomFeaturesTooltip = {
  header:
    "Room Features are typically amenities in a set of rooms.  These are things that a guest could ask for when making a reservation.  A feature does not have to be room type specific; multiple rooms in multiple room types (and buildings for that matter) can share the same feature. \n If every room in your establishment has the same feature, don’t include it.",
  featureCode:
    "The description used within the software.  Feature codes are limited to six characters.",
  featureName: "The description used on reports",
};

// Room Location
export const roomLocationTooltip = {
  header:
    "Room Locations are typically where a room is located (in addition to possibly in a specific Building).  These are things that a guest could ask for when making a reservation.  A location does not have to be room type specific; multiple rooms in multiple room types (and buildings for that matter) can share the same feature.",
  locationCode: "The description used within the software",
  locationName: "The description used on reports",
};

// Housekeeping Section
export const housekeepingTooltip = {
  header:
    "Housekeeping Sections allow the property to break up the hotel rooms into smaller sections, typically by floor, building, geographical location etc. These sections make it easier for the property to assign Housekeeping Boards in the morning to their GRA's. ",
  sectionCode: "A unique code to identify the housekeeping section. ",
  sectionName:
    "A name for the housekeeping section in the property. Up to 50 alphanumeric characters are supported.",
  buildingName:
    "Select the building where the housekeeping section is located. The records created in the Building Codes (Setup → Room → Building Codes) screen are listed as options.",
};

// Room Maintainence Section
export const roomMaintainenceTooltip = {
  header:
    "Room Types are used to classify different rooms as the same type.  Room types can be used to identify rooms by amenities or by almost any other method you currently use.  If this is an amenity that a large number of rooms share, it could be separated into its own room type (1 King Bed, 2 Queen Beds, ADA Compliant, etc.).  If only a few rooms have the same amenity, then consider using Feature or Locations of those particular rooms. A Room Type can only be in a single building.  If you are using Building Codes, a different room type will need to be created for each building.",
  roomTypeCode: "The description used within the software",
  roomTypeName: "The description used on reports",
  building: "The building for this room type",
  allowedReservationType:
    "The reservation types that are allowed for the room type. Nightly - Indicates that the room type is available for overnight reservations. Hourly - Indicates that the room type is available for hourly reservations. If neither is selected, the room type will be available for both overnight and hourly stays.",
  roomCount: "Total number of rooms in this room type",
  maxGuests: "The maximum number of guests that can be put into this room type",
  maxNights:
    "The maximum number of nights for which the room type can be booked",
  resortFee: "If a resort fee is applied to this room type",
  licenseFromDate: "The start date of the license for this room type",
  licenseToDate: "The end date of the license for this room type",
};

// room definitions
export const roomDefinitionsTooltip = {
  header:
    "Room Definitions; Now that we have organized the information for the rooms, the rooms can be defined.",
  roomOrder:
    "The order the rooms will display. The system will sort first by List Order then by alphabetical order.",
  roomNumber:
    "The description used within the software.  Room Numbers are alphanumeric, but limited to seven digits.  Keep in mind some interfaces will not accept letters as part of a room number.",
  roomType: "The description used on reports.",
  building:
    "The building the room will be associated to when searching or reporting on the rooms.",
  suite: "Does this room use Suite logic?",
  condo: "Does this room have a condo owner?",
  numberOfBeds: "Total number of beds in this room.",
  allowPets: "Does this property allow pets?",
  petCount: "How many pets can be in this room?",
  smoking:
    "Is this a smoking room (an ‘X’ or something similar is fine in this column).",
  connectingRooms: "Rooms that have connecting doors to this room.",
};

// department
export const departmentsTooltip = {
  header:
    "Departments are used to logically (and financially) group post types.",
  departmentName:
    "The description of the department.  Used in the software, and on reports.",
};

// category
export const categoryTooltip = {
  header:
    "Categories are for more detailed financial reporting. These are associated to departments, categories are optional. If the property wants more detailed and layered financial reporting categories are recommended.",
  categoryName: "The name of the category",
  departmentName:
    "The name of the associated department (please refer to the department tab)",
};

// taxes
export const taxesTooltip = {
  header:
    "Taxes are applied to the post types that are created in the system. Please consider taxes not only for the hotel, but also taxes that come over from the POS if you are tracking POS financials within the Versa PMS.",
  taxType:
    "The name of the post type selected will automatically be displayed. Users can edit this field if preferred.",
  postType:
    "Search for a post type by post type number or by the name of the post type.",
  exemptChangeDays:
    "The number of days the guest must stay in the property to be exempted from the tax.",
  effectiveDays: "The date from when the tax must be in effect.",
  pstTax:
    "A list of Provincial Sales Tax (PST) codes created using the PST Codes option under the General (Settings → Setup) menu are displayed in the drop-down list.",
  extractCode:
    "Enter the code for the extract information from the extract types.",
  listOrder:
    "The position in which the tax type must appear in the grid. By default, the system automatically generates a value based on the value of the  previously created list item.",
  active: "When enabled, it indicates that the tax type is active.",
  taxable: "When enabled, it indicates that the created tax is taxable",
};

// tax exempt category
export const taxExemptCategoryTooltip = {
  header:
    "Tax Exempt Categories are designed to be added to specific taxes, which controls what taxes are available for Tax Exemption if selected on a reservation or group booking. *NOTE* If there is no Tax Exemption Category attached to the Tax, the tax will not be available for tax exemption.",
  taxExemptCategoryCode: "The short code for the Tax Exemption Category",
  taxExemptCategoryName: "The long form name of the Tax Exemption Code",
  active: "When enabled, it indicates that the Tax Exempt Category is active.",
  listOrder:
    "The position in which the Tax Exempt Category must appear in the grid. By default, the system automatically generates a value based on the value of the  previously created list item.",
};

// guest type
export const guestTypeTooltip = {
  header:
    "What type of guest is this?  Three general classifications that you will hear Versa refer to often are Transient (Individual social guests), Group (Guests linked to a booking) and DAY (Guests not staying at the Hotel, but have billing privileges).",
  guestTypeCode:
    "The description used within the software. Guest Type codes are limited to 15 characters.",
  guestTypeName: "The description used on reports.",
  routeLocalCalls:
    "Indicate whether the local calls must be routed to Admin folio or not. (No Routing or Route Local Calls. Any local phone calls made to a reservation with this guest type are not charged to the guest folio.The routing selected for the guest type overrides the value selected for the origin and segment codes.)",
  turndownService:
    "This indicates that the turndown service is enabled for this guest type, and will indicate to Housekeeping that this guest is provided a second service during the day to prepare the bed for use that night. Please use TRUE for Yes and FALSE for No.",
  skipResortFee:
    "This indicates that when this guest type is used on a reservation, that guest will not be charged the hotel resort fee.  Please use TRUE for Yes skip the resort fee and FALSE for No, do not skip the resort fee.",
  creditCardPreAuthAmount:
    "Pre-authorize a guest credit card for incidental charges. This amount overrides the system default. This is for incidental charges only and the room and tax charges are authorized at the full amount.",
  taxExemptCategories:
    "The preferred tax categories that can be exempted for the guest type. Tax Exempt Categories are created in the system, please use categories built in workbook.",
  active:
    "Will this Guest Type be available for use in the system? Please use TRUE for IS active and FALSE if the feature is NOT active.",
};

// post types
export const postTypesTooltip = {
  header:
    "Post Types are individual transaction items that are posted to guest folios, groups, house accounts etc. Such as, Room Charge, Champagne, Valet, Cancellation, Visa Deposit, etc.. The charges are linked to specific departments and categories for revenue tracking.",
  department: "The department under which the post type must be created.",
  category: "The category under which the post type must be created",
  postTypeNumber:
    "A unique code to identify the post type. The user can click Auto Generate to use the system generated number for the post type. Up to 15 alphanumeric characters are supported.",
  postTypeName:
    "A name for the post type. Up to 50 alphanumeric characters are supported.",
  active: "When enabled, it indicates that the post type is active.",
  credit:
    "When enabled, it indicates that when this post type is used, the charges are recorded as a negative balance.",
  deposit:
    "When enabled, it indicates that when this post type is used, the charges are recorded in the deposit ledger.",
  characteristics:
    "Select a default payment method for the post type. The following options are available:▪ Debit▪ Credit Card▪ Cash▪ City Ledger▪ Check▪ Other Credit",
  postTypeCategory:
    "The category code for the post type, for example, Revenue and Nonrevenue Debit",
  defaultBuilding:
    "The building to which revenue from the post type must be added.",
  defaultAmount: "Default Amount ($) The default amount for the post type.",
  floorLimit:
    "The minimum value for which the user can post charges using this post type.",
  ceilingLimit:
    "The maximum value for which the user can post charges using this post type. The value entered as the ceiling limit must be less than or equal to the default amount of the post type.",
  groupingFunctionality:
    "The user can group one or more post types belonging to the same department under the selected post type and add a fee for each post type. By default, the None option is selected. On selecting the Fixed, Percentage, or Open option, the Add or Edit Grouping window appears. The user can select the department to view the mapped post types, select the post types to be grouped, and configure the rates for it. The sum of all individual post types must match the default amount configured for the main post type. When a user posts charges for this grouped post type, the Statement tab will only display one (combined) record, which includes charges for all post types, instead of a separate record for each grouped post type.",
  requireReference:
    "When enabled, it indicates that the user must enter reference details or a transaction reference in the Reference field of the Posting screen at the time of posting charges.",
  requireComment:
    "When enabled, it indicates that users must enter comments in the Comment field of the Posting screen when posting charges for the post type.",
  restrictReservationPost:
    "When enabled, it indicates that the user cannot post charges for the post type when the reservation is in the Resv status.",
  passcode:
    "When enabled, it indicates that the user must enter a passcode to post charges for the post type.",
  roomRevenue:
    "When enabled, the charges posted against the post type are mapped to the room revenue buckets.",
  foodandBeverageClassifier:
    "When enabled, the charges posted against the post type are mapped to the food and beverage classifiers.",
  defaultFolio:
    "The default folio for the post type. That is, if a folio is not selected by the user when posting charges using the post type, the charges will be posted to the folio number entered here.",
  defaultMasterFolio: "The default master folio number for the general ledger.",
  generalLedgerNumber: "The account number of the general ledger.",
  generalLedgerOffsetNumber: "The offset general ledger account number.",
  sageExtractNumber: "The sage extract number.",
  extractRevenueBucket: "The extract revenue bucket number.",
  commissionable:
    "When enabled, it indicates that the charges posted against the post type are commissionable.",
  commissionFlat: "The flat amount value of the commission.",
  chargedToCondoOwner:
    "When enabled, it indicates that the charges against the post type are posted to the condo owner.",
  useCommission:
    "When enabled, it indicates that the system uses percentage values for commissions.",
  commissionPercentage: "The percentage value of the commission.",
  giftCardFunctionality:
    "When enabled, the gift certificate functionality for the post type is enabled.",
  giftCardType:
    "Select the preferred external gift card type for the post type.",
};

// origin
export const originsTooltip = {
  header: "Where did the reservation originate?",
  originCode:
    "The description used within the software. Origin codes are limited to 15 characters.",
  originName: "The description used on reports.",
  routeLocalCalls:
    "Indicate whether the local calls must be routed to Admin folio or not. Any local phone calls made to a reservation with this guest type are not charged to the guest folio. The routing selected for the guest type overrides the value selected for the origin and segment codes.",
  active:
    "Will this be available for use in the system? Please toggle TRUE for IS active and toggle FALSE if the feature is NOT active.",
};

// payment methods
export const paymentMethodsTooltip = {
  header:
    "Payment Methods are the accepted forms of payment to close a folio on a guest reservation.",
  paymentMethodCode:
    "The description used within the software.  Payment Method codes are limited to eight characters.",
  paymentMethodName: "The description used on reports.",
  paymentType:
    "This determines how Versa will react when a specific payment method is selected on a reservation",
  postTypeNumber:
    "Indicate the number associated to the post type in which this payment method is attached to.  These should be based on the post types created in this workbook.",
  useSpecialGuarantee:
    "When this field is TRUE, the reservation will be marked as a guaranteed reservation. Please use FALSE if the reservation is not guaranteed with this Payment Method.",
  creditLimit:
    "Is there a maximum amount that can be authorized or collected with this payment method? If YES, please fill in the amount, if NOT then leave field blank.",
  activeInterface:
    "This needs to be marked TRUE for ALL Credit Card payment methods. Marked FALSE for all other payment methods.",
  restrictPOSCharges:
    "When marked TRUE this indicates that the point of sale charges are not allowed for the payment method. When a guest goes to a restaurant or retail shop they will not be permitted to charge back to their hotel room. When marked FALSE the guest will be able to charge back to their hotel room.",
  allowAllMovies:
    "When marked TRUE this indicates that the in room movies are allowed for the payment method.  When marked FALSE the guest will NOT be able to charge in room movies. ",
  allowPostToCheckOut:
    "When marked TRUE this indicates that  the payment method can used on a checked out folio.  When marked FALSE the payment method cannot be used on a checked out folio.",
  centralReservationEquivalent:
    "Used only for customers who have multi-property configuration and have one central reservation team. This allows the central reservation team to see one payment name in the case that each property utilizes a different names for the payments.",
  phoneRestrictions: "Select a preferred phone restriction for the payments",
  active:
    "Will this Payment Method be available for use in the system? Please use TRUE for IS active and FALSE if the feature is NOT active.",
};

// transportation
export const transportationTooltip = {
  header:
    "The transportation page is used to gather the information about the nearby transportation facilities that are available close to the property",
  listName: " The name of the facility available",
  transportationType: " The type of the facility available",
  location: " The exact location is mentioned accordingly",
  approxMiles: "The exact miles it available from the property",
  approxTime:
    "The approximate time taken to reach the facility from the property",
  modeOfTransport: "Mode of Transport",
};

// customer segments
export const customerSegmentsTooltip = {
  header1:
    "What type of guest is this?  Three general classifications that you will hear Versa refer to often are Transient (Individual social guests), Group (Guests linked to a booking) and DAY (Guests not staying at the Hotel, but have billing privileges). Segments tie back to Guest Types allowing for additional classification on a specific Guest Type.",
  segment1Code:
    "The description used within the software. Segment 1 codes are limited to eight characters.",
  segment1Name: "The description used on reports.",
  routeLocalCalls:
    "Indicate whether the local calls must be routed to Admin folio or not. Any local phone calls made to a reservation with this Segment 1 are not charged to the guest folio. The routing selected for the Guest Type overrides the value selected for the origin and segment codes",
  systemOptions: "Leave Blank Route Local Calls No Routing",
  guestTypeCode:
    "Indicate the guest type to which the segment code is attached to. These should be based on the Guest Types created in this workbook.",
  active1:
    "Will this Segment 1 be available for use in the system? Please use TRUE for IS active and FALSE if the feature is NOT active.",
  header2:
    "The market channel is used for tracking the market/source that brought the guest to the hotel.",
  segment2Code:
    "The description used within the software. Market Channel codes are limited to eight characters.",
  segment2Name: "The description used on reports.",
  parentSegment1:
    "Indicate the segment 1 to which this Segment 2, is attached. These codes are based on the codes that should be built in the Segment 1 tab of this workbook.",
  guestTypeCode2:
    "Indicate the guest type to which the Segment 2 code is attached. These codes should be based on the codes  that should be built in the Guest Type tab of this workbook.",
  active2:
    "Will this Segment 2 be available for use in the system? Please use TRUE for IS active and FALSE if the feature is NOT active.",
};

export const golfTooltipHeaders = {
  outletName: "The name of the outlet.",
  active: "Active",
  terminalID: " Enter Terminal ID here. Enter 1 here",
  profitCenterId:
    "Leave this field blank; This will be autopopulated based on your outlet setup.",
  autoPrintReceipts:
    "If you'd like to automatically print receipts in this outlet, enter Yes.  if not, enter No.",
  courseName: "The name of the golf course",
  defaultOutlet:
    "The name of the outlet where golfers will be checking in for this course.",
  hole9: "If this is hole 9 course.",
  hole18: "If this is hole 9 course.",
  allocationBlockCode: "The abbreviated code of the allocation block.",
  allocationBlockName: "The name of the allocation block.",
  allocationBlockColor:
    "The color shown for this allocation block on the tee sheet. Enter a hex color code (e.g. #000000). Each allocation block must have a unique color.",
  daysOut:
    "The number of days before it will change to a different code if not booked.",
  allocationTime: "The time you want this allocation code to switch.",
  showOnTeeSheet:
    "Do you want the name of the allocation code to show on the tee time.  Enter TRUE if yes and FALSE if no (if false, then only the color will show, not the name).",
  closed:
    " Is this allocation code open to booking or is it closed?  Enter TRUE for open to book and FALSE if closed.",
  playerType: "The name of the player type.",
  daysOutStart:
    "This signifies the earliest tee time date and the latest tee time date available for that player type.  For example, if you set up a Resort Guest player type and set the Days Out Start to 0 and the Days Out End to 21, then a resort guest may book a tee time up to 3 weeks out in addition to being able to book on the day of play (0 days).",
  daysOutEnd:
    "This signifies the earliest tee time date and the latest tee time date available for that player type.  For example, if you set up a Resort Guest player type and set the Days Out Start to 0 and the Days Out End to 21, then a resort guest may book a tee time up to 3 weeks out in addition to being able to book on the day of play (0 days).",
  guaranteePlayerType:
    " Is there a member number, resort confirmation number or credit card requirement on this player type? None:  No requirement on this player type; Enter Yes or No.  Member: This player type requires a member number; Enter Yes or No. Resort:  This player type requires a resort confirmation number; Enter Yes or No. Credit:  This player type requires a credit card; Enter Yes or No.",
  availableForWebPlayerType:
    "Is this the player type that will be used for online tee times?  Only the one player type that is used for online bookings will be marked Yes here.",
  rateType: "The name of the rate type",
  guaranteeRateType:
    "Is there a member number, resort confirmation number or credit card requirement on this rate type?  Use EITHER player type restrictions or rate type restrictions on a single player type/rate type.  Do not use the same restriction on both player type and rate type.",
  suppressOnReceipt:
    "When this rate type is checked out and paid, would you like to NOT show the dollar value on the receipt?  Enter TRUE to suppress the rate on the receipt and FALSE to show the rate on the receipt (this is sometimes turned on for hotel package golf rates, so the guest doesn't see the value of that green fee inside the package)",
  availableOnWebRateType:
    "If this rate type is available to select on the web, enter TRUE here. If not an online rate type, then enter FALSE",
  minPlayers:
    " If this rate type IS available online, then enter the minimum number of players that can book a tee time with this rate type online.  I.e. the Online 18 Advanced rate type can be booked only if there are at least 2 players in the group.  So this would not allow a single player to book this rate type online.",
  allocationBlock: "The name of the allocation block.",
  startDate: "Starting date for this range of tee times.",
  endDate: "Ending date for this range of tee times.",
  startTime:
    "This is the first tee time of the day.  You should consider the time of year in setting this time as winter tee times will differ from summer tee times due to darkness, frost, etc..  ",
  endTime:
    "This is the last tee time of the day.  Here again, consider the time of year when setting this end time.",
  minMinutes: "The number of minutes between tee times.",
  availableDaysInAWeek:
    "The days of the week that this rate is available.  Enter Yes on the days it is available and No on the days it is not available.",
  holeNumber: " The hole number on which the player stopped playing",
  greenFeePer:
    "The percentage of their paid green fee for which they will receive credit",
  cartFeePer:
    " The percentage of their paid cart fee for which they will receive credit",
  greenFee:
    "The flat dollar amount of the green fee that they will be credited (if not using percentages)",
  cartFee:
    "The flat dollar amount of the cart fee that they will be credited (if not using percentages)",
  roleCode: "Short code for the role ",
  roleName: "the name of the role",
  categoryGroup:
    " The name of the category group. This is not used when you have an integration to Inventory Management like Eatec,Yellow Dog and Red Rock. It is used for Reporting Purposes",
  categoryName: "The name of the retail category",
  eligibleForDiscount: " Is this category eligible to discount?  Yes or No",
  subCategoryName:
    "Name of the subcategory. Level 1 is the highest (most broad) level of the categorization. Level 5 is the most specific or narrow level of categorization.",
  taxName: " The name of the tax.  This name will appear on the receipts.",
  allowTaxonServiceCharge:
    "Enter Yes if service charge is subject to this tax.  If not, enter No",
  allowTaxonGratuity:
    "Enter Yes if gratuity is subject to this tax.  If not, enter No",
  percentageOrFlatAmount:
    "Is this tax calculated as a percentage (%) or flat amount ($)?",
  value: "The dollar or percentage amount of the tax",
  startDateTax: "The date you will start charging this tax",
  endDateTax: "The date you will stop charging this tax",
  defaultToAllItems:
    "If you'd like the system to automatically check this box on every retail item created, then enter Yes.  If this tax would not apply to every retail item, then enter No.  (This saves the user a click in the retail item entry process.  You can always check and uncheck that box manually at any time.",
  discountType: "Name of the discount",
  quickSaleCategory: "Name of the quick sale category",
  vendorSetupHeader: "List each Vendor setup below",
  vendorTypes:
    "Vendor Types allow you to group similar vendors together based on what products they sell. You may have multiple vendors from whom you get golf balls or other equipment.  This can be a separate vendor type from Apparel.",
  discountTypes:
    "The Discount Types section allows users to set up named, pre-set discounts that can be applied to items or services sold in the shop. The discount value can be added in the discount configuration tab.",
  startDateRatesSetup: "The date this rate starts",
  endDateRatesSetup: "The date this rate ends",
  startTimeRatesSetup:
    "The time this rate starts  (if available all day, then leave this field blank)",
  endTimeRatesSetup:
    "The time this rate ends  (if available all day, then leave this field blank)",
  time: "The Time for the block.",
  discountReason: "The desciption of the reason",
  allowSinglePlayerTeeTime:
    "Toggle Yes if want to allow single player in Open Tee time",
  greenFeeItem: "The item number in your retail setup for this green fee",
  cartFeeItem: "The item number in your retail setup for this cart fee",
  propertyInformationHeader:
    "This page is intended to collect the contact and location information for the golf resort.",
  outletSetupHeader: "List each outlet setup below.",
  courseHeader: "List each golf course below.",
  allocationBlockHeader:
    "Tee time allocation codes or blocks are used to restrict what type of player can book in a certain tee time slot.  It can also indirectly control which rate types can book in certain tee time slots.  For example, you may have a tee time allocation block called Resort Guest and you allocate all tee times within 7:30am - 8:00am to this allocation code.  You can then allow only the Resort Guest player type to book in those tee times.  You may also need an allocation code for Closed or Maintenance or Starter Time to control pace of play.  You can also set an allocation code to change to a different allocation code on a schedule.  For example, for the Resort Guest only tee time in the above example, you may want that to change back to Open if it hasn't been booked by 7:00am day of play.  You can set those parameters here as well.",
  playerTypeHeader: "Enter your player types below.",
  rateTypesHeaders:
    "Rate Types are rate codes that determine how much a golfer will pay for a round of golf.",
  playerAllocationBlockHeader:
    "Allocation Block/Player Type Linking allows you to specify which rate types can be booked with with player type and which player type can be booked on which allocation code. When booking tee times, the drop down lists that the user will choose from will only contain those codes that are linked here to make it more efficient.",
  teeTimeIntervalHeader: "Please provide tee sheet details for each course.",
  rainCheckSetupHeader:
    "Rain checks give you a way to offer a credit to a player in the event you have to close the course due to weather or if the player is not able to finish their round.  They can then use that credit towards their next round of golf.  Usually, this is given in the form of percentage of the round played, but it can be a flat amount if preferred",
  roleSetupHeader:
    "Role Setup if for creating different groups of users with the same permissions.  These roles are then assigned specific permissions and then assigned to user names. ",
  categoryGroupsHeader:
    "Retail Category Groups are created to help with reporting. In specific reports, the user can select a Category Group to filter out items they are not interested in seeing on the report. Examples of Category Groups may be Golf Green Fees, Golf Retail, etc. These are intended to be broad categories. ",
  retailCategoryHeaders:
    "Retail Categories are for high level reporting of revenue, grouping your sales together by types such as Green Fees, Cart Fees, Golf Balls, Golf Accessories, etc.  Retail Categories can be associated to Category Groups.",
  retailSubCategoryHeaders:
    "Retail Sub Categories allow for the property to add additional layers to the reporting on retail items and further categorizing. Such as: Men, Women, Large, Small, Shirts, etc. The system allow for up to 5 additional layers of categorizing.",
  taxesHeaders:
    "All taxes are to be entered here.  Please include any special taxes that you have, like Amusement Tax, Alcohol Tax, etc.",
  discountTypesHeaders:
    "The Discount Types section allows users to set up named, pre-set discounts that can be applied to items or services sold in the shop. The discount value can be added in the discount configuration tab.",
  quickSaleHeader:
    "Quick Sale Categories are designed to group common items together on your point of sale screen.  Under each quick sale category, you will set up quck sale buttons in the system that the users can select to sell the item.",
  vendorTypeHeader:
    "Vendor Types allow you to group similar vendors together based on what products they sell. You may have multiple vendors from whom you get golf balls or other equipment.  This can be a separate vendor type from Apparel.",
  discountReasonsHeader:
    "You can require the user to enter a reason when applying a discount in the point of sale.  You can provide a drop down selection box for them with these different reasons in it.",
  ratesSetupHeader:
    "This is where you list all of your rates and when they are available.",
};

/** Retail — Category Groups */
export const retailCategoryGroupsTooltip = {
  header:
    "Retail Category Groups are created to help with reporting. In specific reports, the user can select a Category Group to filter out items they are not interested in seeing on the report. An example of Category Groups may be Apparel if you'd like to make your revenue categories more specific. These are intended to be broad categories.",
  categoryGroup: "The name of the category group",
  active: "Is this category group active?  Yes or No",
  listOrder: "The order in which this category group appears in list",
};

/** Retail — Retail Sub Categories */
export const retailRetailSubCategoriesTooltip = {
  header:
    'Retail Sub Categories allow for the property to add additional layers to the reporting on retail items and further categorizing. Such as: Shirts, Shoes, Belts, Candles, Bedding, etc. The system allow for up to 5 additional layers of categorizing.\n\nThe examples below illustrate that each of the columns is independent of each other at this time.  You will be asked to "map" these subcategories to its "parent" on the next tab.',
  level1:
    "Sub category name level 1 — the highest (most broad) level of categorization.",
  level2:
    "Sub category name level 2 — between level 1 and level 5 in the hierarchy.",
  level3:
    "Sub category name level 3 — between level 1 and level 5 in the hierarchy.",
  level4:
    "Sub category name level 4 — between level 1 and level 5 in the hierarchy.",
  level5:
    "Sub category name level 5 — the most specific or narrow level of categorization.",
  active: "Is this subcategory active?  Yes or No",
};

/** Retail — Category Linking */
export const retailCategoryLinkingTooltip = {
  header:
    "Category Linking is used to link subcategories together as well as to link subcategories to the main category.\n\nWhen creating new retail items, the drop down lists that the user will choose from on Category and Subcategories will only contain those codes that are linked here to make it more efficient.  For example, subcategories like Shirts and Shorts would only be linked to Mens Apparel or Womens Apparel.",
  mainCategory: "The name of the main retail category",
  subcategory1: "The name of the subcategory level 1",
  subcategory2: "The name of the subcategory level 2",
  subcategory3: "The name of the subcategory level 3",
  subcategory4: "The name of the subcategory level 4",
  subcategory5: "The name of the subcategory level 5",
};

/** Retail — Retail Categories */
export const retailRetailCategoriesTooltip = {
  header:
    "Retail Categories are for high level reporting of revenue, grouping your sales together by types such as Mens Apparel, Womens Apparel, Accessories, Gifts, etc.  Retail Categories can be associated to Category Groups.",
  categoryGroup: "The name of the category group this category belongs to",
  categoryName: "The name of the retail category",
  listOrder: "The order in which this category appears in the list",
  active: "Is this category active?  Yes or No",
  eligibleForDiscount: "Is this category eligible to discount?  Yes or No",
  eligibleForCostPlus:
    "Is this category eligible for cost plus pricing?  Yes or No",
};

/** Retail — Outlet Setup */
export const retailOutletSetupTooltip = {
  header: "List each retail outlet below.",
  outletName: "The name of the shop or outlet",
  terminalId: "Enter 1 here",
  profitCenterId:
    "Leave this field blank; This will be autopopulated based on your outlet setup",
  autoPrintReceipts:
    "If you'd like to automatically print receipts in this outlet, enter Yes.  if not, enter No.",
  active: "Is this outlet active?  Yes or No",
};

/** Retail — Quick Sale Categories */
export const retailQuickSaleCategoriesTooltip = {
  header:
    "Quick Sale Categories are designed to group common items together on your point of sale screen.  Under each quick sale category, you will set up quick sale buttons in the system that the users can select to sell the item.",
  quickSaleCategory: "Name of the quick sale category",
  outletName:
    "The name of the outlet where this quick sale category will be used",
  active: "Is this quick sale category active?  Yes or No",
};

/** Retail — Discount Types */
export const retailDiscountTypesTooltip = {
  header:
    "The Discount Types section allows users to set up named, pre-set discounts that can be applied to items or services sold in the shop. The discount value can be added in the discount configuration tab.",
  discountType: "Name of the discount",
};

/** Retail — Discount Reasons */
export const retailDiscountReasonsTooltip = {
  header:
    "You can require the user to enter a reason when applying a discount in the point of sale.  You can provide a drop down selection box for them with these different reasons in it.",
  discountReason: "The description of the reason",
  active: "Is this reason active?  Yes or No.",
};

/** Retail — Vendor Types */
export const retailVendorTypesTooltip = {
  header:
    "Vendor Types allow you to group similar vendors together based on what products they sell. For example, you may have multiple vendors from whom you get bath products.  This can be a separate vendor type from face products.",
  vendorType: "Enter name of the vendor.",
};

/** Retail — Vendor Setup */
export const retailVendorSetupTooltip = {
  header:
    "Enter details of your retail item vendors here.   The Vendor Name will appear on vendor reports, but all else is informational only.",
  vendorType:
    "The type of products this vendor supplies.  Select from Vendor Types listing.",
  vendorCode: "The short name for this vendor",
  vendorName: "The full name of this vendor",
  firstName: "The first name of the vendor representative",
  lastName: "The last name of the vendor representative",
  addressLine1: "The address line 1 of the vendor representative",
  addressLine2: "The address line 2 of the vendor representative",
  city: "The city of the vendor representative",
  state: "The state of the vendor representative",
  country:
    "The country of the vendor representative.  If US, enter United States.",
  postalCode: "The postal code of the vendor representative",
  phoneType:
    "The type of phone number of the vendor representative.  Enter Home, Office or Mobile",
  countryCode:
    "The country code of the vendor representative's phone number.  For US and North America, enter 1",
  phoneNumber:
    "The phone number for the vendor representative.  Enter numbers only",
  emailType:
    "The type of email of the vendor representative.  Enter Office or Personal",
  emailAddress: "The email address for the vendor representative",
  comments: "Any comments for this vendor.  This is an open text field.",
  terms: "Terms for this vendor.  This is an open text field.",
};

/** Retail — Retail Items */
export const retailRetailItemsTooltip = {
  header:
    "This is the master list of all the retail items that you sell in your shop.",
  itemNumber: "The item number of this item",
  itemDescription:
    "The description of the item.  This is what the guest will see on the receipt.",
  category: "The revenue category for this item",
  subCategory1: "The subcategory 1 of this item.  Leave blank if none.",
  subCategory2: "The subcategory 2 of this item.  Leave blank if none.",
  subCategory3: "The subcategory 3 of this item.  Leave blank if none.",
  subCategory4: "The subcategory 4 of this item.  Leave blank if none.",
  subCategory5: "The subcategory 5 of this item.  Leave blank if none.",
  unitOfMeasure: "The unit of measure for this item.  Leave blank if none.",
  salesPrice: "The retail sales price for this item",
  barCode:
    "The primary bar code for this item.  Must match the item number field.",
  secondaryBarCode:
    "The secondary or manufacturer's bar code for this item.  Leave blank if none.",
  tax: "The full name of the taxes associated with this item.  If multiple taxes apply, enter them separated by commas",
  itemType: "Enter a 1 in this field for every item.  1 = Retail Item",
  commissionPercent: "Leave this field blank.",
  commissionableItem:
    "Enter a 1 in this field if the item is commissionable.  Leave blank if not commissionable.",
  commissionRequired:
    "If commission is required on the sale of this item, then enter 1.  If not, leave blank.",
  useInventory:
    "If this is a retail item that you count as inventory, enter 1.  If not, leave blank",
  groupingKey: "Leave this field blank",
  openItems: "Leave this field blank",
  multipacks: "Leave this field blank",
  gratuity: "Leave this field blank",
  serviceCharge: "Leave this field blank",
  outletCode:
    "The name of the outlet or outlets where this item is sold.  If it is sold in multiple outlets, enter each outlet separated by a comma.  Leave this field blank if you want to sell this item in ALL outlets - must then enter a 1 in Outlet Switch column",
  quantity: "The quantity of this item",
  unitCost: "The wholesale cost of this item",
  itemPar:
    "If you'd like to set a par level for this item (i.e. minimum 4 items on the shelf), then enter that par number.  If not, leave this field blank",
  outletSwitch:
    "If you've entered the outlet name where this item is sold in the Outlet Code field, then enter 0 here.  If Outlet Code field is blank, then enter 1 here and the item will be added to all outlets.",
  allowEarn:
    "Used with casino integration.  If the sale of this item earns casino points, then enter 1.  If not or if no casino interface exists, then leave this field blank",
  vendorName: "The full name of the vendor who provides this item",
  vendorItemNo: "the supplier pick number for this item",
};

/** Retail — Taxes */
export const retailTaxesTooltip = {
  header:
    "All taxes are to be entered here.  Please include any special taxes that you have, like Amusement Tax, Alcohol Tax, etc.",
  outlet: "The name of the outlet",
  taxName: "The name of the tax.  This name will appear on the receipts.",
  allowTaxOnServiceCharge:
    "Enter Yes if service charge is subject to this tax.  If not, enter No",
  allowTaxOnGratuity:
    "Enter Yes if gratuity is subject to this tax.  If not, enter No",
  percentageOrFlatAmount:
    "Is this tax calculated as a percentage (%) or flat amount ($)?",
  value: "The dollar or percentage amount of the tax",
  startDate: "The date you will start charging this tax",
  endDate: "The date you will stop charging this tax",
  defaultToAllRetailItems:
    "If you'd like the system to automatically check this box on every retail item created, then enter Yes.  If this tax would not apply to every retail item, then enter No.  (This saves the user a click in the retail item entry process.  You can always check and uncheck that box manually at any time.)",
};

/** Retail — Payment Methods */
export const retailPaymentMethodsTooltip = {
  header: "Payment Methods are the accepted forms of payment in the shop.",
  paymentMethodName: "The name of the payment method",
  active: "Is this payment method active?  Yes or No",
  requireReceipts: "Do you require receipts for this payment method? Yes or No",
  numberOfReceipts:
    "The number of receipts to print when using this payment method",
  requireComment:
    "Do you require the user to enter a comment when using this payment method?  Yes or No",
};

/** Retail — Role Setup */
export const retailRoleSetupTooltip = {
  header:
    "Role Setup if for creating different groups of users with the same permissions.  These roles are then assigned specific permissions and then assigned to user names.",
  roleCode: "Short code for the role",
  roleName: "the name of the role",
  active: "Is this role active?  Yes or No",
};

/** Retail — User Setup */
export const retailUserSetupTooltip = {
  header:
    "Set up all users who will have access to Retail.  Please include non-retail personnel, such as Accounting/Finance, Hotel Reservations, etc if they will require access to do anything in the retail program.",
  firstName: "The first name of the user",
  lastName: "The last name of the user",
  userId:
    "The user ID for this user.  This is what they will use to log into the application.",
  quickId:
    "the user's quick two or three digit code if quickID has been activated",
  emailAddress: "email address of the user",
  language: "Select English.  No other language is supported at this time",
  passwordExpirationDate:
    "You can leave this one blank if you want the system to auto generate the password exp date based on PCI compliancy rules",
  newPassword:
    "A generic password that you will give to all users.  They will enter this password to then be able to create their own.",
  applicationAccess: "Enter Retail here",
  active: "Is this user active?  Yes or No",
  allowGratuity:
    "If this user is eligible to receive discretionary gratuities, then enter Yes.  If no, then enter No.",
  allowServiceCharge:
    "If this user is eligible to receive service charge, then enter Yes.  If no, then enter No.",
  allowCommission:
    "If this user is eligible to receive commission on sales of items or services, then enter Yes.  If no, then enter No.",
  commissionClass:
    "If you entered Yes to Allow Commission, what commission class does this user belong to.  Commission classes are setup to avoid having to touch every new commissionable item every time you add.  It's a grouping used for setting up commission amounts en masse.",
  outletAccess:
    "Enter the name of the retail outlet this user will have access to; separate each outlet with a comma",
  roleNameUser: "This user's role name",
  accountBlocked:
    "Used only for inactive users.  Enter No if user can access the system and Yes if they are blocked from accessing the system.",
  autoLogOff:
    "Do you want the system to automatically log off this user after a certain number of minutes? Enter Yes or No.",
  logOffMinutes:
    "If you entered Yes in Auto Log Off, then this is the number of minutes before auto logging off the user",
};

export const spaTooltipHeaders = {
  propertyInformationHeader:
    "This page is intended to collect the contact and location information for the resort.",
  propertyInformationPropertyName: "Property Name",
  propertyInformationAddressLine1: "Address Line 1",
  propertyInformationAddressLine2: "Address Line 2",
  propertyInformationAddressLine3: "Address Line 3",
  propertyInformationState: "State",
  propertyInformationCity: "City",
  propertyInformationPostalCode: "Postal Code",
  propertyInformationCountry: "Country",
  propertyInformationPhoneType: "Phone Type",
  propertyInformationCountryCode: "Country Code",
  propertyInformationPhoneNumber: "Phone number",
  propertyInformationLanguage: "Language",

  serviceGroupHeader:
    "Service Groups are the different types of services you offer and can be used to filter availability when booking an appointment.  For example, the user may wish to only see the therapists that do massage.  Enter your different types of services, or service groups, here.",
  serviceGroupServiceGroupCode: "Service Group Code",
  serviceGroupServiceGroupDescription: "Service Group Description",
  serviceGroupListOrder: "List Order",

  outletSetupHeader: "List each spa outlet below.",
  outletSetupOutletName: "The name of the shop or outlet",
  outletSetupTerminalId: "Enter 1 here",
  outletSetupProfitCenterId:
    "Leave this field blank; This will be autopopulated based on your outlet setup",
  outletSetupAutoPrintReceipts:
    "If you'd like to automatically print receipts in this outlet, enter Yes.  if not, enter No.",
  outletSetupActive: "Is this outlet active?  Yes or No",

  roleSetupHeader:
    "Role Setup if for creating different groups of users with the same permissions.  These roles are then assigned specific permissions and then assigned to user names.",
  roleSetupRoleCode: "Short code for the role",
  roleSetupRoleName: "the name of the role",
  roleSetupActive: "Is this role active?  Yes or No",

  therapistSetupHeader:
    "Set up each spa therapist or service provider who performs treatments. Enter a unique Staff Code, name, contact details, and pay settings such as hourly rate, gratuity, service charge, and commission eligibility. Use Display on Appointment Grid to control whether the provider appears when booking appointments. During the database build, therapists will be linked to the services they perform.",
  therapistSetupStaffCode:
    "A unique code for this therapist.  This can be an alpha numeric code that is 10 characters or less.",
  therapistSetupFirstName: "The first name of the therapist",
  therapistSetupLastName: "The last name of the therapist",
  therapistSetupGender:
    "Select the gender for this therapist. Choose Male, Female, Non-Binary, or Prefer Not to Say.",
  therapistSetupDateOfHire:
    "The date when this therapist was hired.  You can leave blank or you can enter their actual hire date in the past.  For reference only.",
  therapistSetupSeniorityLevel:
    "The seniority level for this therapist. Lower numbers typically indicate higher seniority and can be used when prioritizing appointment assignments or scheduling order. Leave blank if not used.",
  therapistSetupAka:
    "Also known as (AKA) name for this therapist. Use this if the provider goes by a different name on the appointment grid or with guests than their legal first or last name.",
  therapistSetupHourlyRate:
    "The therapist's hourly pay rate. Used for payroll and reporting. Leave blank if this provider is not paid hourly.",
  therapistSetupDisplayOnAppointmentGrid:
    "If this therapist should appear on the appointment grid when booking services, enter Yes. Enter No if the provider should be hidden from scheduling, such as for inactive or administrative staff.",
  therapistSetupPhoneType:
    "The type of phone number provided.  Enter Mobile, Home, or Office.",
  therapistSetupCountryCode:
    "The country code for this phone number.  North America country code is 1.",
  therapistSetupPhoneNumber:
    "The phone number for this therapist (no punctuation please).",
  therapistSetupAllowGratuity:
    "If this therapist is eligible to receive discretionary gratuities, then enter Yes.  if not, enter No.",
  therapistSetupAllowServiceCharge:
    "If this therapist is eligible to receive service charge, then enter Yes.  If no, then enter No.",
  therapistSetupAllowCommission:
    "If this therapist is eligible to receive commission on sales of items or services, then enter Yes.  If no, then enter No.",
  therapistSetupCommissionClass:
    "If you entered Yes to Allow Commission, enter the commission class this therapist belongs to. Commission classes are set up to avoid having to touch every new commissionable item each time you add one. They are a grouping used for setting up commission amounts en masse.",
  therapistSetupEmailType:
    "The type of email address provided.  Enter Personal, Work, or Other.",
  therapistSetupEmailAddress: "The email address for this provider",

  serviceLocationHeader:
    "Set up the locations where services are performed here.  Don't forget to include stations for manicures and pedicures, make up application and hair services, if applicable.",
  serviceLocationLocationCode: "The short code of the location",
  serviceLocationLocationName:
    "The description of the location.  This location name will appear at the top of the appointment grid when in Location View.",
  serviceLocationListOrder:
    "The order in which the location will appear in the list.  This is also the order in which the system gets the next location available when Auto Select Location is turned on.",
  serviceLocationMaximumNumberOfGuests:
    "this is the maximum number of guests allowed in this location.  Entering 0 will allow any number of guests.  Entering 2 will allow up to 2 guests in that location, etc.  Example:  If you have a Hammam or Hydrotherapy area, these locations may allow up to 5 or 6 guests or more.",
  serviceLocationLocationDescription: "Location Description",

  serviceEquipmentHeader:
    "Set up equipment used in spa treatments here.  These pieces of equipment are those that you move around as needed, and you only have a limited number of each.  For example, you may only have 1 steamer that is on wheels and used for one or two particular facials.  You can perform those facials in any facial room, but there can only be one booked at a time if they need the steamer.  The steamer is the piece of equipment and 1 is the quantity on hand.  If you have a steamer in every facial room then this is not considered movable equipment.  Think of things like pregnancy pillows, wax pots, stone sets, portable massage beds if you do in-room treatments, etc.",
  serviceEquipmentEquipmentCode: "The short code for this piece of equipment",
  serviceEquipmentEquipmentDescription: "The name of the equipment",
  serviceEquipmentQuantity: "How many of this equipment do you have?",

  cancelReasonHeader:
    "Cancel Reasons are used when a guest cancels his or her appointment(s).  You have the option to require the user to select a reason for the cancellation from a drop down box.",
  cancelReasonCancelReason: "the description of the reason",
  cancelReasonActive: "Is this reason active?  Yes or No",
  cancelReasonListOrder:
    "The order in which the reason appears on drop down list. By default, the system automatically generates a value based on the value of the previously created list item.",

  serviceMedicalConditionHeader:
    "Medical Conditions can be attached to a service to pop a warning to the user when booking that service.  Medical Conditions can also be attached to a client.  If the user is trying to book a client with the same medical condition as is attached to the service, then the warning will pop up and show the user the medical contraindications of booking that service for that client. You can choose to not attach medical conditions to services or clients, or you may choose to only set up the serious medical conditions and only attach them to services.  You can choose to what degree you will use Medical Conditions.",
  serviceMedicalConditionConditionCode: "The short code of the description",
  serviceMedicalConditionPrivateCondition:
    "If this is a private condition and you don't want the user to see it on their client record, then enter Yes.  If not, enter No.",
  serviceMedicalConditionConditionDescription:
    "The long description of the medical condition",
  serviceMedicalConditionConditionWarning:
    "The warning that will pop up on the screen for the user when booking a service with this medical condition on it.",

  noShowReasonHeader:
    "No Show Reasons are used when a guest doesn't show up for his or her appointment(s).  You have the option to require the user to select a reason for the no show from a drop down box.",
  noShowReasonNoShowReason: "the description of the reason",
  noShowReasonActive: "Is this reason active?  Yes or No",
  noShowReasonListOrder:
    "The order in which the reason appears on drop down list. By default, the system automatically generates a value based on the value of the previously created list item.",

  breakTypeHeader:
    'There are different reasons why a therapist may not be available to perform a treatment.  When you need to pull a therapist out of rotation to get appointments, you can put them on a "break".  They will then be unavailable during that time.  Enter your different types of breaks here.',
  breakTypeBreakTypeCode: "the short code of the break",
  breakTypeBreakTypeDescription:
    "The description of the break.  This is what the users will see on the appointment grid.",
  breakTypeIncludeInUtilitization:
    "If this break is by choice of the therapist, then you would enter No here.  This number of minutes would then not be included in the number of minutes this therapist is booked.  If this break is mandatory, then enter Yes here.  The number of minutes for this break would be included in the total number of minutes booked, thereby not penalizing the therapist for being unavailable through no fault of their own.",
  breakTypePaid:
    "If the therapist is paid during this break, enter Yes. If this is an unpaid break, enter No.",

  lostDeniedReasonHeader:
    "Lost/Denied Reasons are used when business is lost or denied.  Enter the reasons you could lose or deny business here.",
  lostDeniedReasonLostDeniedReason: "the description of the reason",
  lostDeniedReasonActive: "Is this reason active?  Yes or No",

  logTypeHeader:
    "Log Types are used when making notes about clients or appointments.  You can categorize what type of note it is.",
  logTypeLogType: "the description of the log type",
  logTypeActive: "Is this Log Type active?  Yes or No",

  guestTypeHeader:
    "Guest types allow you to identify the types of guests that frequent your spa.  You can then get reporting on the number of appointments for each guest type.",
  guestTypeGuestTypeCode: "the short code for this guest type",
  guestTypeGuestTypeDescription: "the name of this guest type",
  guestTypeListOrder:
    "The order in which this guest type will appear in the drop down list",

  priceTypeHeader:
    "Price types allow you to define different pricing categories for spa services.",
  priceTypePriceTypeCode: "the short code for this price type",
  priceTypePriceTypeDescription: "the description of this price type",

  serviceHeader:
    "List your services with all their details here.  During the database build you will manually attach the therapist who do the treatments and the locations where the treatments can be done.  You will also manually add the equipment needed and the add ons that can be performed with the treatment.  This sheet provides the shell of the service setup.",
  serviceServiceGroup: "The service group that this service belongs to",
  serviceServiceCode:
    "The short code of the service.  This needs to be 10 characters or less and it does not allow special characters or punctuation.",
  serviceServiceDescription: "The description or name of the service",
  serviceServicePoints: "If using points, how many points is this service?",
  serviceAvailableDaysInAWeek:
    "The days of the week that this service is available. Select the days when this service can be booked.",
  serviceAvailableSun:
    "If this service is available on Sunday, enter Yes.  If not, enter No.",
  serviceAvailableMon:
    "If this service is available on Monday, enter Yes.  If not, enter No.",
  serviceAvailableTue:
    "If this service is available on Tuesday, enter Yes.  If not, enter No.",
  serviceAvailableWed:
    "If this service is available on Wednesday, enter Yes.  If not, enter No.",
  serviceAvailableThu:
    "If this service is available on Thursday, enter Yes.  If not, enter No.",
  serviceAvailableFri:
    "If this service is available on Friday, enter Yes.  If not, enter No.",
  serviceAvailableSat:
    "If this service is available on Saturday, enter Yes.  If not, enter No.",
  serviceEffectiveFromDate: "The start date of this service",
  serviceEffectiveToDate: "The end date of this service",
  serviceServicePrice:
    "The price of the service.  If you offer seasonal or weekend pricing, enter your default price here.  During the database build, you can setup your seasonal or weekend pricing directly in the software.",
  serviceServiceTime: "The duration of this service. Enter number of minutes",
  serviceSetupTime: "The setup time for this service. Enter number of minutes",
  serviceBreakdownTime:
    "The breakdown time for this service.  Enter number of minutes",
  serviceListOrder:
    "The order in which this service will appear in the drop down boxes of services",
  serviceMinimumAge:
    "The minimum age to have this service.  This is informational only unless you are requiring birthdate for booking.",
  serviceMinimumGuests: "The minimum number of guests for this service",
  serviceMaximumGuests: "The maximum number of guests for this service",
  serviceMinimumStaff:
    "The minimum number of therapists needed for this service",
  serviceMaximumStaff:
    "The maximum number of therapists needed for this service",
  serviceOffsite:
    "If this service is available to be booked offsite, enter Yes here.  If it is required to be done in a location in the spa, enter No. (Usually, it's only In Room or Chair Massages that would be marked Yes here).",
  serviceAutoGratuity:
    "Is this service subject to an automatic gratuity?  Enter Yes or No.",
  serviceAutoGratuityPercentage:
    "If above field is Yes, enter the percentage gratuity to apply",
  serviceAutoServiceCharge:
    "If this service is subject to an automatically service charge being applied, enter Yes.  If no auto service charge, then enter No.",
  serviceAutoServiceChargePercentage:
    "If above field is Yes, enter the percentage service charge to apply",
  serviceCommissionable:
    "If this service is commissionable to the therapist, enter Yes.  If no commission is earned on this service, enter No.",
  serviceAvailableOnWeb:
    "If this service is available to be booked on the web, then enter Yes.  If not, then enter No.",
  serviceInactive: "Is this service inactive?  Enter Yes or No.",
  serviceLinkedItem:
    'The number of the linked retail item for this service.  Every service must have a retail item setup under "Item Numbers for Services" tab.',
  servicePriceType: "The price type(s) associated with this service",
  serviceServiceEquipment: "The equipment required to perform this service",
  serviceServiceLocations:
    "The location(s) where this service can be performed",
  serviceServiceComment:
    "Optional comments or notes about this service. This is an open text field.",

  addOnHeader:
    "Service add ons are enhancements to services that do not require extra time to do.  (If the add on requires time, then it needs to be set up as a service).  Examples of add ons are Paraffin Hands, Paraffin Feet, Lip Treatment, Eye Treatment.",
  addOnServiceAddOnName:
    "The name of the add on.  This is also the name that will appear online if applicable.",
  addOnCommissionable:
    "If this add on is commissionable, then enter Yes.  If not, enter No.",
  addOnAvailableOnWeb:
    "If this add on is available to be booked on the web, then enter Yes.  If not, enter No.",
  addOnRetailCategory:
    "When sold, what retail category will the revenue go to?  Ex:  a massage add on would go to Massage",
  addOnPrice: "The price of the add on",
  addOnLinkedItem:
    'The retail item this add on is attached to.  Each add on needs a retail item set up under "Item Numbers for Add Ons" tab.',
  addOnDurationMins: "The duration of the add on in minutes",
  addOnPoints: "The points of the add on",

  dayPackageHeader:
    "Day Packages allow you to combine services together and offer them at a special price.  You will enter the details of each package here.  During your database build, you will select the services that are part of each package. This will get the shell of the package created in the system.",
  dayPackagePackageCode: "The short code for this package",
  dayPackagePackageDescription: "The long description of this package",
  dayPackageStartDate: "The date you can start selling this package",
  dayPackageEndDate:
    "The date you will stop selling this package.  If you want to make this available indefinitely, enter a far off future date here.",
  dayPackagePrice:
    "Price of the package. This will autopopulate based on the prices of the services inside that package",
  dayPackageAvailableSun:
    "If this package is available to book on Sunday, enter Yes.  If it is not offered on Sunday, enter No.",
  dayPackageAvailableMon:
    "If this package is available to book on Monday, enter Yes.  If it is not offered on Monday, enter No.",
  dayPackageAvailableTue:
    "If this package is available to book on Tuesday, enter Yes.  If it is not offered on Tuesday, enter No.",
  dayPackageAvailableWed:
    "If this package is available to book on Wednesday, enter Yes.  If it is not offered on Wednesday, enter No.",
  dayPackageAvailableThu:
    "If this package is available to book on Thursday, enter Yes.  If it is not offered on Thursday, enter No.",
  dayPackageAvailableFri:
    "If this package is available to book on Friday, enter Yes.  If it is not offered on Friday, enter No.",
  dayPackageAvailableSat:
    "If this package is available to book on Saturday, enter Yes.  If it is not offered on Saturday, enter No.",
  dayPackageNumberOfPeople:
    "The number of people on this package.  If it is an individual package, then enter 1.  If it is a couples package, enter 2.",
  dayPackageMaxNumberOfDays:
    "If this package is only offered in one day, then enter 1.  If you can have the treatments on this package over the course of more than one day, enter that many days here.  For example, if it's a package with three services on it and the guest can have two of those services today and the third service tomorrow, then enter 2.",
  dayPackageLinkedItem:
    'The retail item this package is linked to.  Each package must have a retail item created under "Item Numbers for Packages" tab.',
  dayPackageActive:
    "If this package is active, then enter Yes.  If it is inactive, enter No.",

  categoryGroupHeader:
    "Retail Category Groups are created to help with reporting. In specific reports, the user can select a Category Group to filter out items they are not interested in seeing on the report. Examples of Category Groups may be Spa Services and Spa Retail, etc. These are intended to be broad categories.",
  categoryGroupCategoryGroup: "The name of the category group",
  categoryGroupActive: "Is this category group active?  Yes or No",
  categoryGroupListOrder:
    "The order in which this category group appears in list",

  retailCategoryHeader:
    "Retail Categories are for high level reporting of revenue, grouping your sales together by types such as Massage, Facial, Apparel, Spa Gifts, Retail Skin Care, etc.  Retail Categories can be associated to Category Groups.",
  retailCategoryCategoryGroup:
    "The name of the category group this category belongs to",
  retailCategoryCategoryName: "The name of the retail category",
  retailCategoryListOrder:
    "The order in which this category appears in the list",
  retailCategoryActive: "Is this category active?  Yes or No",
  retailCategoryEligibleForDiscount:
    "Is this category eligible to discount?  Yes or No",

  retailSubCategoryHeader:
    "Retail Sub Categories allow for the property to add additional layers to the reporting on retail items and further categorizing. Such as: Men, Women, Large, Small, Robes, Moisturizer, Lotion, etc. The system allow for up to 5 additional layers of categorizing.",
  retailSubCategorySubcategory1: "Name of the subcategory",
  retailSubCategorySubcategory2: "Name of the subcategory",
  retailSubCategorySubcategory3: "Name of the subcategory",
  retailSubCategorySubcategory4: "Name of the subcategory",
  retailSubCategorySubcategory5: "Name of the subcategory",
  retailSubCategoryActive: "Is this subcategory active?  Yes or No",
  retailSubCategoryListOrder:
    'The order in which this subcategory appears in list The examples below illustrate that each of the columns is independent of each other at this time.  You will be asked to "map" these subcategories to its "parent" on the next tab.',

  categoryLinkingHeader:
    "Category Linking is used to link subcategories together as well as to link subcategories to the main category. When creating new retail items, the drop down lists that the user will choose from on Category and Subcategories will only contain those codes that are linked here to make it more efficient.  For example, subcategories like cleansers and moisturizers would only be linked to Retail Skin Care, but Apparel may have several levels of subcategory linking.",
  categoryLinkingMainCategory: "The name of the main retail category",
  categoryLinkingSubcategory1: "The name of the subcategory level 1",
  categoryLinkingSubcategory2: "The name of the subcategory level 2",
  categoryLinkingSubcategory3: "The name of the subcategory level 3",
  categoryLinkingSubcategory4: "The name of the subcategory level 4",
  categoryLinkingSubcategory5: "The name of the subcategory level 5",

  paymentMethodHeader:
    "Payment Methods are the accepted forms of payment in the spa.",
  paymentMethodPaymentMethodName: "The name of the payment method",
  paymentMethodListOrder:
    "The order in which the payment method will appear on the payment screen",
  paymentMethodActive: "Is this payment method active?  Yes or No",
  paymentMethodRequireReceipts:
    "Do you require receipts for this payment method? Yes or No",
  paymentMethodOfReceipts:
    "The number of receipts to print when using this payment method",
  paymentMethodRequireComment:
    "Do you require the user to enter a comment when using this payment method?  Yes or No",
  paymentMethodAllowChange:
    "Enter Yes if the tendered amount can be changed for this payment method at the point of sale. Enter No if not.",
  paymentMethodOutletCode:
    "The outlet code associated with this payment method, if applicable.",
  paymentMethodDefault:
    "Enter Yes if this payment method should be selected by default. Enter No if not.",

  taxHeader:
    "All taxes are to be entered here.  Please include any special taxes that you have, like Amusement Tax, Alcohol Tax, etc.",
  taxOutlet: "The name of the outlet",
  taxTaxName: "The name of the tax.  This name will appear on the receipts.",
  taxAllowTaxOnServiceCharge:
    "Enter Yes if service charge is subject to this tax.  If not, enter No",
  taxAllowTaxOnGratuity:
    "Enter Yes if gratuity is subject to this tax.  If not, enter No",
  taxPercentageOrFlatAmount:
    "Is this tax calculated as a percentage (%) or flat amount ($)?",
  taxValue: "The dollar or percentage amount of the tax",
  taxStartDate: "The date you will start charging this tax",
  taxEndDate: "The date you will stop charging this tax",
  taxDefaultToAllRetailItems:
    "If you'd like the system to automatically check this box on every retail item created, then enter Yes.  If this tax would not apply to every retail item, then enter No.  (This saves the user a click in the retail item entry process.  You can always check and uncheck that box manually at any time.)",

  discountTypeHeader:
    "The Discount Types section allows users to set up named, pre-set discounts that can be applied to items or services sold in the shop. The discount value can be added in the discount configuration tab.",
  discountTypeDiscountType: "Name of the discount",

  quickSaleCategoryHeader:
    "Quick Sale Categories are designed to group common items together on your point of sale screen.  Under each quick sale category, you will set up quick sale buttons in the system that the users can select to sell the item.",
  quickSaleCategoryQuickSaleCategory: "Name of the quick sale category",
  quickSaleCategoryOutletName:
    "The name of the outlet where this quick sale category will be used",
  quickSaleCategoryActive: "Is this quick sale category active?  Yes or No",
  quickSaleCategoryListOrder:
    "The order in which this quick sale category appears in list.  By default, the system automatically generates a value based on the value of the previously created list item.",

  serviceItemNumberHeader:
    "Each service must be set up as an item in your point of sale system.  Typically, you should create one item for each service that you offer so that you can get accurate revenue reporting.",
  serviceItemNumberItemNumber:
    "the item number for this service; system will auto generate this if you leave blank here",
  serviceItemNumberCategory:
    "the category where revenue will go for this service (i.e. Massage)",
  serviceItemNumberItemDescription:
    "The description of this item, usually the name of the service",
  serviceItemNumberCommissionable:
    "If this service is commissionable to the therapist, then enter Yes.  If not, enter No.",
  serviceItemNumberSpaService:
    "This is a required field that marks each one as a spa service.  Enter Yes for all.",
  serviceItemNumberTaxable: "Is this service item taxable? Enter Yes or No.",
  serviceItemNumberActive: "Is this item active? Enter Yes or No.",

  addOnItemNumberHeader:
    "Each add on must be set up as an item in your point of sale system.  Typically, you should create one item for each add on that you offer so that you can get accurate revenue reporting.",
  addOnItemNumberItemNumber:
    "the item number for this add on; system will auto generate this if you leave blank here",
  addOnItemNumberCategory:
    "the category where revenue will go for this add on (i.e. Manicure)",
  addOnItemNumberItemDescription:
    "The description of this item, usually the name of the add on",
  addOnItemNumberCommissionable:
    "If this add on is commissionable to the therapist, then enter Yes.  If not, enter No.",
  addOnItemNumberSpaAddOn:
    "This is a required field that marks each one as a add on.  Enter Yes for all.",
  addOnItemNumberTaxable: "Is this add on item taxable? Enter Yes or No.",
  addOnItemNumberActive: "Is this item active? Enter Yes or No.",

  dayPackageItemNumberHeader:
    "Each package must be set up as an item in your point of sale system.  Typically, you should create one item for each package that you offer so that you can get accurate revenue reporting.",
  dayPackageItemNumberItemNumber:
    "the item number for this package; system will auto generate this if you leave blank here",
  dayPackageItemNumberCategory:
    "the category you can use to search for this package in the retail setup",
  dayPackageItemNumberItemDescription:
    "The description of this item, usually the name of the package",
  dayPackageItemNumberSpaPackage:
    "This is a required field that marks each one as a spa package.  Enter Yes for all.",
  dayPackageItemNumberActive: "Is this item active? Enter Yes or No.",
  dayPackageItemNumberType:
    "The item type for this row. Select Day Package for package items.",

  discountReasonHeader:
    "You can require the user to enter a reason when applying a discount in the point of sale.  You can provide a drop down selection box for them with these different reasons in it.",
  discountReasonDiscountReason: "The description of the reason",
  discountReasonActive: "Is this reason active?  Yes or No.",

  vendorTypeHeader:
    "Vendor Types allow you to group similar vendors together based on what products they sell. For example, you may have multiple vendors from whom you get bath products.  This can be a separate vendor type from face products.",
  vendorTypeVendorType: "Vendor Type",

  vendorHeader:
    "Enter details of your retail item vendors here.   The Vendor Name will appear on vendor reports, but all else is informational only.",
  vendorVendorType:
    "the type of products this vendor supplies.  Select from Vendor Types listing.",
  vendorVendorCode: "the short name for this vendor",
  vendorVendorName: "the full name of this vendor",
  vendorFirstName: "The first name of the vendor representative",
  vendorLastName: "The last name of the vendor representative",
  vendorAddressLine1: "The address line 1 of the vendor representative",
  vendorAddressLine2: "The address line 2 of the vendor representative",
  vendorCity: "The city of the vendor representative",
  vendorState: "The state of the vendor representative",
  vendorCountry:
    "The country of the vendor representative.  If US, enter United States.",
  vendorPostalCode: "The postal code of the vendor representative",
  vendorPhoneType:
    "The type of phone number of the vendor representative.  Enter Home, Office or Mobile",
  vendorCountryCode:
    "The country code of the vendor representative's phone number.  For US and North America, enter 1",
  vendorPhoneNumber:
    "The phone number for the vendor representative.  Enter numbers only",
  vendorEmailType:
    "The type of email of the vendor representative.  Enter Office or Personal",
  vendorEmailAddress: "The email address for the vendor representative",
  vendorComments: "Any comments for this vendor.  This is an open text field.",
  vendorTerms: "Terms for this vendor.  This is an open text field.",

  retailItemHeader:
    "This is the master list of all the retail items that you sell in your spa.",
  retailItemItemNumber: "The item number of this item",
  retailItemItemDescription:
    "The description of the item.  This is what the guest will see on the receipt.",
  retailItemCategory: "The revenue category for this item",
  retailItemSubCategory1:
    "The subcategory 1 of this item.  Leave blank if none.",
  retailItemSubCategory2:
    "The subcategory 2 of this item.  Leave blank if none.",
  retailItemSubCategory3:
    "The subcategory 3 of this item.  Leave blank if none.",
  retailItemSubCategory4:
    "The subcategory 4 of this item.  Leave blank if none.",
  retailItemSubCategory5:
    "The subcategory 5 of this item.  Leave blank if none.",
  retailItemUnitOfMeasure:
    "The unit of measure for this item.  Leave blank if none.",
  retailItemSalesPrice: "The retail sales price for this item",
  retailItemBarCode:
    "The primary bar code for this item.  Must match the item number field.",
  retailItemSecondaryBarCode:
    "The secondary or manufacturer's bar code for this item.  Leave blank if none.",
  retailItemTax:
    "The full name of the taxes associated with this item.  If multiple taxes apply, enter them separated by commas",
  retailItemItemType:
    "Enter a 1 in this field for every item.  1 = Retail Item",
  retailItemCommissionPercent: "Leave this field blank.",
  retailItemCommissionableItem:
    "Enter a 1 in this field if the item is commissionable.  Leave blank if not commissionable.",
  retailItemCommissionRequired:
    "If commission is required on the sale of this item, then enter 1.  If not, leave blank.",
  retailItemUseInventory:
    "If this is a retail item that you count as inventory, enter 1.  If not, leave blank",
  retailItemGroupingKey: "Leave this field blank",
  retailItemOpenItems: "Open Items",
  retailItemMultipacks: "Leave this field blank",
  retailItemGratuity: "Leave this field blank",
  retailItemServiceCharge: "Leave this field blank",
  retailItemOutletCode:
    "The name of the outlet or outlets where this item is sold.  If it is sold in multiple outlets, enter each outlet separated by a comma.  Leave this field blank if you want to sell this item in ALL outlets - must then enter a 1 in Outlet Switch column",
  retailItemQuantity: "The quantity of this item",
  retailItemUnitCost: "The wholesale cost of this item",
  retailItemItemPar:
    "If you'd like to set a par level for this item (i.e. minimum 4 items on the shelf), then enter that par number.  If not, leave this field blank",
  retailItemOutletSwitch:
    "If you've entered the outlet name where this item is sold in the Outlet Code field, then enter 0 here.  If Outlet Code field is blank, then enter 1 here and the item will be added to all outlets.",
  retailItemAllowEarn:
    "Used with casino integration.  If the sale of this item earns casino points, then enter 1.  If not or if no casino interface exists, then leave this field blank",
  retailItemVendorName: "The full name of the vendor who provides this item",
  retailItemVendorItem: "the supplier pick number for this item",
};
